(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["listicle-shapewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var revealTargets = document.querySelectorAll('.listicle-shapewear .reveal-on-scroll');
    if ('IntersectionObserver' in window && revealTargets.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealTargets.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    var stickyCta = document.querySelector('.listicle-shapewear__sticky-cta');
    var featuredItem = document.querySelector('.listicle-shapewear__item--featured');
    if (stickyCta && featuredItem && 'IntersectionObserver' in window) {
      var ctaObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.boundingClientRect.top < 0) {
              stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
            }
          });
        },
        { threshold: 0 }
      );
      ctaObserver.observe(featuredItem);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
